import React, { useEffect } from 'react';
import Joi from 'joi';
import { useSelector } from 'react-redux';
import { useFieldset, useDispatchCallback } from 'controls/hooks';
import { hasAnEmptySpace, removeEmptySpaces } from 'controls/utils';
import { validateVoucher } from 'actions/voucher';
import { Container } from 'components/layout/Container';
import { Language } from 'language/Language';
import { Input } from 'components/atoms/Input/Input';
import { Button } from 'components/atoms/Button/Button';
import { productLink } from 'productLink';
import { voucherStrings } from './strings';

import './Voucher.scss';

const VoucherForm = { voucher: '' };
const VoucherSchema = { voucher: Joi.string().required().label('Voucher') };

const Voucher = () => {
  const language = Language();

  const { countryUser } = useSelector((state) => state.siteInfo);

  const { fields: { voucher }, submit, loading } = useFieldset({
    schema: VoucherSchema,
    source: VoucherForm,
    onSubmit: useDispatchCallback(validateVoucher),
  });

  useEffect(() => {
    if (hasAnEmptySpace(voucher.value)) {
      voucher.onChange(removeEmptySpaces(voucher.value));
    }
  }, [voucher]);

  return (
    <Container>
      <div className='voucher'>
        <p className='voucher__text'>{voucherStrings[language].question}</p>
        <form onSubmit={submit} className='voucher__form'>
          <Input
            field={voucher}
            placeholder='xxxx-xxxx-yyy-aaa'
            classes='input voucher__input'
          />
          <div className='voucher__button'>
            <Button
              loading={loading}
              text={voucherStrings[language].validate}
              type='submit'
            />
          </div>
        </form>
        {countryUser === 'JP'
          ? (
            language === 'japan'
              ? (
                <p className='voucher__link'>
                  { voucherStrings[language].text}
                  <a href={productLink} target='_blank' rel='noreferrer'>
                    {voucherStrings[language].here}
                  </a>
                  {voucherStrings[language].text2}
                </p>
              )
              : (
                <p className='voucher__link'>
                  {voucherStrings[language].text}
                  <a href={productLink} target='_blank' rel='noreferrer'>
                    {voucherStrings[language].here}
                  </a>
                </p>
              )
          ) : ''}
      </div>
    </Container>
  );
};

export default Voucher;
